import { render } from "./AggregatorDetail.vue?vue&type=template&id=0e39403c&scoped=true"
import script from "./AggregatorDetail.vue?vue&type=script&lang=js"
export * from "./AggregatorDetail.vue?vue&type=script&lang=js"

import "./AggregatorDetail.vue?vue&type=style&index=0&id=0e39403c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e39403c"]])

export default __exports__